import {AllApiSchema} from '@shared/api/core/api_schema';
import {ApiConfig, ApiName} from '@shared/api/core/api_types';
import {MAVISMART_BACKEND} from '@shared/api/mavismart_backend';
import {MAVISMART_TECMOTION_WEBHOOK} from '@shared/api/mavismart_tecmotion_webhook';
import {MAVISMART_BACKEND_URL, MAVISMART_TECMOTION_WEBHOOK_URL} from '@shared/env';

export const ALL = {
  mavismart_backend: MAVISMART_BACKEND,
  mavismart_tecmotion_webhook: MAVISMART_TECMOTION_WEBHOOK,
} satisfies AllApiSchema;

export const API_CONFIGS = {
  mavismart_backend: {host: MAVISMART_BACKEND_URL},
  mavismart_tecmotion_webhook: {host: MAVISMART_TECMOTION_WEBHOOK_URL},
} satisfies Record<ApiName, ApiConfig>;
